import classnames from "classnames";
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { createPortal } from "react-dom";
import { Transition } from "react-transition-group";
import Card from '../Card';
import Icon from '../Icon';
import './modal.scss';

const CONTAINER_NAME = `bwl-modal-container`;

const Modal = ({children, open: propOpen, onClose, className, containerClassName}) => {
  const classes = classnames(className, "bwl-modal");
  const [open, setOpen] = useState(propOpen);
  const [container, setContainer] = useState(
    document.getElementById(CONTAINER_NAME)
  );

  useEffect(() => {
    setOpen(propOpen);
  }, [propOpen]);

  useEffect(() => {
    if (!container) {
      const c = document.createElement("div");
      c.setAttribute("id", CONTAINER_NAME);
      if(containerClassName) c.setAttribute("class", containerClassName);
      document.body.appendChild(c);
      setContainer(c);
    }
  }, [container]);

  const handleCloseClick = () => {
    setOpen(false);
    if (onClose) {
      onClose();
    }
  };

  const content = (
    <Transition in={open} timeout={250}>
      {(state) => {
        const backdropClasses = classnames("bwl-modal-backdrop", {
          "bwl-modal-backdrop--entering": state === "entering",
          "bwl-modal-backdrop--entered": state === "entered",
          "bwl-modal-backdrop--exiting": state === "exiting",
          "bwl-modal-backdrop--exited": state === "exited",
          "bwl-modal-backdrop--unmounted": state === "unmounted",
        });
        return (
          <div className={backdropClasses} onClick={onClose && handleCloseClick}>
            <Card className={classes} onClick={(e) => e.stopPropagation()}>
              {onClose && 
                <button className="bwl-modal-close-button" onClick={onClose && handleCloseClick} >
                  <Icon icon="close" noMargin small/>
                </button>
              }
              {children}
            </Card>
          </div>
        )}
      }
    </Transition>
  );
  if (!container) return null;
  return createPortal(content, container);
};

export default Modal;

Modal.propTypes = {
  children: PropTypes.node,
  open: PropTypes.bool,
  onClose: PropTypes.func
};

